export default function PhilosophySection() {
  return (
    <section className="py-28 bg-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
          <div>
            <h2 className="text-4xl md:text-6xl font-bold text-gray-800 mb-8 leading-tight" style={{ fontFamily: "'Cormorant Garamond', serif" }}>
              기술은 사람을 자립하게 하고
              <br />
              <span className="text-emerald-600">자립은 사람을 존중받게 합니다</span>
            </h2>
            <p className="text-base text-gray-600 leading-relaxed">
              우리는 기술이 단순한 생산 수단을 넘어, 사람의 삶을 변화시키는 힘이라고 믿습니다. 
              한 사람 한 사람의 기술이 모여 공동체를 이루고, 그 공동체가 지속가능한 산업을 만들어갑니다.
            </p>
          </div>

          <div className="grid grid-cols-2 gap-4">
            <div className="relative rounded-xl overflow-hidden shadow-lg">
              <img
                src="https://public.readdy.ai/ai/img_res/52cf9be774edfc79fc4a13c09f4c927b.jpg"
                alt="공방 작업"
                className="w-full h-full object-cover object-top"
              />
            </div>
            <div className="relative rounded-xl overflow-hidden shadow-lg mt-12">
              <img
                src="https://readdy.ai/api/search-image?query=Korean%20craftspeople%20working%20on%20industrial%20sewing%20machines%20in%20bright%20workshop%20natural%20lighting%20Korean%20workers%20collaborative%20environment%20sustainable%20fashion%20production%20authentic%20workspace%20photography%20simple%20clean%20background&width=400&height=500&seq=daygreen-phil-kr-2&orientation=portrait"
                alt="공동 작업"
                className="w-full h-full object-cover object-top"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}